import { InferType, object } from 'yup';
import { Nullable } from '../../../model/common';
import { safeString } from './common';

export const resetPasswordSchema = object({
    current_password: safeString().required('Current Password can not be empty.'),
    new_password: safeString().required('New Password can not be empty.'),
    confirm_new_password: safeString()
        .required('Confirm Password can not be empty.')
        .test('passwords-match', 'Confirm Password does not match with the New Password.', function (value) {
            return this.parent.new_password === value;
        })
});

export type ResetPasswordFormValues = InferType<typeof resetPasswordSchema>;
export type ResetPasswordFormInput = Nullable<ResetPasswordFormValues>;
